module.exports = __webpack_public_path__ + "static/1984-desktop-e82f78cf3e8052792469c600d3592ad3.png";